import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Tag, message, Spin } from "antd";
import axios from "axios";
import SummaryApi from "../../../common/index";

const { TextArea } = Input;
const { Option } = Select;

const AdminQueriesPage = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [messages, setMessages] = useState([]);
  const [reply, setReply] = useState("");
  const [status, setStatus] = useState("");

  const token = localStorage.getItem("adminToken"); // Make sure this is stored on admin login

  // Fetch all user queries
 const fetchAllQueries = async () => {
  try {
    setLoading(true);
    const res = await axios.get(SummaryApi.getAllUserQueries.url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("Admin all queries response:", res.data);
    setQueries(res.data.queries || []); // <-- use res.data.queries
  } catch (err) {
    console.error("Error fetching all queries:", err);
    message.error("Failed to fetch queries");
  } finally {
    setLoading(false);
  }
};


  // Fetch single query details + messages
  const fetchQueryDetails = async (queryId) => {
    try {
      setLoading(true);
      const res = await axios.get(SummaryApi.getQueryDetails(queryId).url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSelectedQuery(res.data.query);
      setMessages(res.data.messages || []);
      setStatus(res.data.query.status);
      setModalVisible(true);
    } catch (err) {
      console.error("Error fetching query details:", err);
      message.error("Failed to fetch query details");
    } finally {
      setLoading(false);
    }
  };

  // Send admin reply
  const handleSendReply = async () => {
  if (!reply) return message.warning("Please enter a reply message");
  try {
    const res = await axios.post(
      SummaryApi.replyToUserByAdmin.url,
      { query_id: selectedQuery.id, message: reply },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      message.success("Reply sent successfully");
      const newMsg = res.data.newMessage; 
      setMessages([...messages, newMsg]);
      setReply("");
    } else {
      message.error(res.data.message || "Failed to send reply");
    }
  } catch (err) {
    console.error("Error sending reply:", err);
    message.error("Failed to send reply");
  }
};

  // Update query status
  const handleStatusChange = async (newStatus) => {
    try {
      await axios.put(
        SummaryApi.updateQueryStatus(selectedQuery.id).url,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Status updated successfully");
      setStatus(newStatus);
      
      setQueries(
        queries.map((q) => (q.id === selectedQuery.id ? { ...q, status: newStatus } : q))
      );
    } catch (err) {
      console.error("Error updating status:", err);
      message.error("Failed to update status");
    }
  };

  useEffect(() => {
    fetchAllQueries();
  }, []);

  const columns = [
   {
    title: "S.No",
    key: "index",
    render: (_, __, index) => index + 1,
  },
    { title: "Subject", dataIndex: "subject", key: "subject" },
    { title: "Category", dataIndex: "category", key: "category" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "blue";
        if (status === "resolved") color = "green";
        else if (status === "in_progress") color = "orange";
        else if (status === "closed") color = "red";
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="link" style={{background:"#1129ce" ,color:"white"}} onClick={() => fetchQueryDetails(record.id)}>
          View Details
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2>Admin: User Queries</h2>
      <Spin spinning={loading}>
        <Table columns={columns} dataSource={queries} rowKey="id" />

        <Modal
          title={`Query Details: ${selectedQuery?.subject}`}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          width={700}
        >
          {selectedQuery && (
            <>
              <p><b>Category:</b> {selectedQuery.category}</p>
              <p><b>Priority:</b> {selectedQuery.priority}</p>
              <p>
                <b>Status:</b>{" "}
                <Select
                  value={status}
                  onChange={handleStatusChange}
                  style={{ width: 150, marginLeft: 10 }}
                >
                  <Option value="open">Open</Option>
                  <Option value="in_progress">In Progress</Option>
                  <Option value="resolved">Resolved</Option>
                  <Option value="closed">Closed</Option>
                </Select>
              </p>
              <p><b>Description:</b> {selectedQuery.description}</p>
              <hr />
              <h4>Messages</h4>
              <div style={{ maxHeight: 300, overflowY: "auto", marginBottom: 10 }}>
                {messages.map((msg, index) => (
                  <div key={index} style={{ marginBottom: 8 }}>
                    <b>{msg.sender_role}:</b> {msg.message}{" "}
                    <span style={{ fontSize: 12, color: "#888" }}>
                      ({new Date(msg.created_at).toLocaleString()})
                    </span>
                  </div>
                ))}
              </div>
              <TextArea
                rows={3}
                placeholder="Write a reply..."
                value={reply}
                onChange={(e) => setReply(e.target.value)}
              />
              <Button
                
                style={{ marginTop: 10, background:"#1129ce",color:"white"}}
                onClick={handleSendReply}
              >
                Send Reply
              </Button>
            </>
          )}
        </Modal>
      </Spin>
    </div>
  );
};

export default AdminQueriesPage;
